// Layout.tsx
import { Layout, LayoutProps } from 'react-admin';
import CustomSidebar from './CustomSidebar.tsx';
import CustomAppBar from './CustomAppBar.tsx';
const CustomLayout = (props: LayoutProps) => (
  <Layout
    {...props}
    sidebar={CustomSidebar}
    appBar={CustomAppBar}
  />
);

export default CustomLayout;
